export interface PublicConfig {
  readonly signalingUrl: string;
}

export async function loadPublicConfig(): Promise<PublicConfig> {
  const response = await fetch("/config.json", { cache: "no-store" });
  if (!response.ok) throw new Error("Impossible de charger la configuration publique");
  const value = await response.json() as Partial<PublicConfig>;
  if (!value.signalingUrl || !/^wss?:\/\//u.test(value.signalingUrl)) throw new Error("URL de signalisation invalide");
  if (location.protocol === "https:" && !value.signalingUrl.startsWith("wss://")) throw new Error("La signalisation doit utiliser WSS");
  return { signalingUrl: value.signalingUrl };
}
